import {Injectable} from '@angular/core';
import {MatPaginatorIntl} from '@angular/material/paginator';

@Injectable()
export class CustomPaginatorIntl extends MatPaginatorIntl {
  override itemsPerPageLabel = $localize`:@@paginator.itemsPerPage:Items per page:`;
  override nextPageLabel = $localize`:@@paginator.nextPage:Next page`;
  override previousPageLabel = $localize`:@@paginator.previousPage:Previous page`;
  override firstPageLabel = $localize`:@@paginator.firstPage:First page`;
  override lastPageLabel = $localize`:@@paginator.lastPage:Last page`;

  override getRangeLabel = (page: number, pageSize: number, length: number): string => {
    if (length === 0 || pageSize === 0) {
      return $localize`:@@paginator.rangeZero:0 of ${length}:length:`;
    }
    length = Math.max(length, 0);
    const startIndex = page * pageSize;
    const endIndex = startIndex < length
      ? Math.min(startIndex + pageSize, length)
      : startIndex + pageSize;
    return $localize`:@@paginator.range:${startIndex + 1}:start: – ${endIndex}:end: of ${length}:length:`;
  };
}
